import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/pages/custom-page/CustomPage.js");
